import { render, staticRenderFns } from "./PsConfigurationPhases.vue?vue&type=template&id=395326d7&scoped=true&"
import script from "./PsConfigurationPhases.vue?vue&type=script&lang=js&"
export * from "./PsConfigurationPhases.vue?vue&type=script&lang=js&"
import style0 from "./PsConfigurationPhases.vue?vue&type=style&index=0&id=395326d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395326d7",
  null
  
)

export default component.exports